module.exports = __webpack_public_path__ + "static/og-image.bfe09f6810a8.png";